import { render } from "./GenericPrivacyPolicy.vue?vue&type=template&id=58f0f240&scoped=true"
const script = {}

import "./GenericPrivacyPolicy.vue?vue&type=style&index=0&id=58f0f240&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f0f240"]])

export default __exports__